<div class="arvore-genealogica-container" #fullscreenContainer [class.fullscreen-active]="isFullscreen">
  <div class="header">
    <div>
      <h1>Árvore Genealógica</h1>
    </div>
    <div class="actions">
      <button class="btn btn-outline-secondary" (click)="alternarTelaCheia()">
        {{ isFullscreen ? 'Sair da tela cheia' : 'Tela cheia' }}
      </button>
      <div class="zoom-controls">
        <button class="btn btn-outline-secondary btn-zoom" (click)="zoomOut()" title="Diminuir zoom">-</button>
        <span class="zoom-value">{{ (treeScale * 100) | number:'1.0-0' }}%</span>
        <button class="btn btn-outline-secondary btn-zoom" (click)="zoomIn()" title="Aumentar zoom">+</button>
        <button class="btn btn-outline-secondary btn-reset" (click)="resetarZoom()" title="Reajustar na tela">Ajustar</button>
        <button class="btn btn-outline-secondary btn-reset" (click)="alternarModoLegivel()" title="Alternar tamanho dos nós">
          {{ modoLegivel ? 'Modo compacto' : 'Modo legível' }}
        </button>
      </div>
      <button class="btn btn-secondary" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" (click)="salvarArvore()" [disabled]="loading">Salvar Árvore</button>
    </div>
  </div>

  <div
    class="tree-wrapper"
    #treeViewport
    [class.panning]="isPanning"
    [class.readable-mode]="modoLegivel"
    (mousedown)="iniciarPan($event)"
    (mousemove)="moverPan($event)"
    (mouseup)="finalizarPan()"
    (mouseleave)="finalizarPan()"
    (wheel)="onWheelZoom($event)">
    <div
      class="tree-content"
      #treeContent
      [style.transform]="'translate(' + treeOffsetX + 'px, ' + treeOffsetY + 'px) scale(' + treeScale + ')'"
      [style.transform-origin]="'top left'">
      <ul class="tree-root">
      <ng-template #recursiveNode let-node>
        <li>
          <div class="node-row">
            <div
              class="node-card"
              [class.node-marked]="node.marcarNo"
              [class.node-compact]="isNoCompacto(node)"
              (click)="abrirEdicaoNo(node)">
              <div class="node-geracao">{{ getDescricaoGeracao(node.geracao) }}</div>
              <div class="node-title">{{ node.nome || 'Novo membro' }}</div>
              <div class="node-filiacao" *ngIf="temFiliacao(node)">Filiação: {{ node.NomePai || '-' }} / {{ node.NomeMae || '-' }}</div>
              <div class="node-meta" *ngIf="temNascimento(node)">N: {{ node.dataNascimento }} {{ node.localNascimento }}</div>
              <div class="node-meta" *ngIf="temCasamento(node)">C: {{ node.dataCasamento }} {{ node.localCasamento }}</div>
              <div class="node-meta" *ngIf="temObito(node)">O: {{ node.dataObito }} {{ node.localObito }}</div>
            </div>
          </div>
          <div class="node-actions">
            <button class="btn btn-xs btn-add" (click)="adicionarFilho(node); $event.stopPropagation()">+</button>
            <button class="btn btn-xs btn-remove" (click)="removerFilhos(node); $event.stopPropagation()">-</button>
          </div>
          <ul *ngIf="node.filhos?.length">
            <ng-container *ngFor="let child of node.filhos">
              <ng-container *ngTemplateOutlet="recursiveNode; context: { $implicit: child }"></ng-container>
            </ng-container>
          </ul>
        </li>
      </ng-template>

      <ng-container *ngTemplateOutlet="recursiveNode; context: { $implicit: treeData }"></ng-container>
      </ul>
    </div>
  </div>

  <div class="modal-backdrop-custom" *ngIf="modalVisible && noSelecionado">
    <div class="modal-card">
      <div class="modal-card-header">
        <h5 class="mb-0">Editar Nó</h5>
        <button type="button" class="btn-close" (click)="fecharModal()"></button>
      </div>
      <div class="modal-card-body">
        <div class="row">
          <div class="col-md-6 form-group">
            <label>Geração</label>
            <input class="form-control" [value]="getDescricaoGeracao(noSelecionado.geracao)" readonly />
          </div>
          <div class="col-md-6 form-group">
            <label>Nome</label>
            <input class="form-control" [(ngModel)]="noSelecionado.nome" />
          </div>
          <div class="col-md-6 form-group">
            <label>Data Nascimento</label>
            <input
              class="form-control"
              [ngModel]="noSelecionado.dataNascimento"
              (ngModelChange)="onDataChange('dataNascimento', $event)"
              maxlength="10"
              placeholder="dd/mm/aaaa" />
          </div>
          <div class="col-md-6 form-group">
            <label>Local Nascimento</label>
            <input class="form-control" [(ngModel)]="noSelecionado.localNascimento" />
          </div>
          <div class="col-md-6 form-group">
            <label>Data Casamento</label>
            <input
              class="form-control"
              [ngModel]="noSelecionado.dataCasamento"
              (ngModelChange)="onDataChange('dataCasamento', $event)"
              maxlength="10"
              placeholder="dd/mm/aaaa" />
          </div>
          <div class="col-md-6 form-group">
            <label>Local Casamento</label>
            <input class="form-control" [(ngModel)]="noSelecionado.localCasamento" />
          </div>
          <div class="col-md-6 form-group">
            <label>Data Óbito</label>
            <input
              class="form-control"
              [ngModel]="noSelecionado.dataObito"
              (ngModelChange)="onDataChange('dataObito', $event)"
              maxlength="10"
              placeholder="dd/mm/aaaa" />
          </div>
          <div class="col-md-6 form-group">
            <label>Local Óbito</label>
            <input class="form-control" [(ngModel)]="noSelecionado.localObito" />
          </div>
          <div class="col-md-12 form-group">
            <label>Observação</label>
            <textarea class="form-control" rows="3" [(ngModel)]="noSelecionado.observacao"></textarea>
          </div>
          <div class="col-md-12 form-group">
            <label class="checkbox-row">
              <input type="checkbox" [(ngModel)]="noSelecionado.marcarNo" />
              Marcar nó
            </label>
          </div>
        </div>
      </div>
      <div class="modal-card-footer">
        <button type="button" class="btn btn-light" (click)="fecharModal()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="fecharModal()">Salvar</button>
      </div>
    </div>
  </div>
</div>
